/**
 * add/remove loading classes
 *
 * Example ("disabled" and "loading" together is not a problem):
 * ```
 *   <button type="submit" v-loading="isLoading" :disabled="isSubmitDisabled">
 *     Search
 *   </button>
 * ```
 */
export default {
  update (el, { value }) {
    let action = value ? 'add' : 'remove'
    el.classList[action]('loading')
  }
}



// WEBPACK FOOTER //
// ./src/directives/loading.js